import { jsx as _jsx } from "react/jsx-runtime";
import ThumbUpIcon from '@heroicons/react/outline/ThumbUpIcon';
import ChevronUpIcon from '@heroicons/react/solid/ChevronUpIcon';
import { ReactionType } from '@tribeplatform/gql-client/types';
import { useI18n, useStaticIntl } from '../../i18n';
import { SingleReaction } from './SingleReaction';
import { SingleReactionWithOptions } from './SingleReactionWithOptions';
const reactionsFactory = ({ $t }) => ({
    '+1': $t({ defaultMessage: 'Like', id: 'Generics.Like.Verb' }),
    heart: $t({ defaultMessage: 'Love', id: 'Generics.Love.Verb' }),
    tada: $t({ defaultMessage: 'Celebrate', id: 'Generics.Celebrate.Verb' }),
    smile: $t({ defaultMessage: 'Smile', id: 'Generics.Smile.Verb' }),
    open_mouth: $t({ defaultMessage: 'Wow!', id: 'Generics.WowBang' }),
    cry: $t({ defaultMessage: 'Cry', id: 'Generics.Cry.Verb' }),
});
export const LikeAction = ({ post, showIcon = true, showText = true, }) => {
    const { $t } = useI18n();
    const reactions = useStaticIntl(reactionsFactory);
    switch (post === null || post === void 0 ? void 0 : post.primaryReactionType) {
        case ReactionType.VOTE_BASE:
            return (_jsx(SingleReaction, { post: post, text: showText
                    ? $t({
                        id: 'Generics.Upvote',
                        defaultMessage: 'Upvote',
                    })
                    : '', showCount: !showText, reaction: "+1", Icon: showIcon ? _jsx(ChevronUpIcon, { className: "w-6 h-6 shrink-0" }, void 0) : null }, void 0));
        case ReactionType.LIKE_BASE:
            return (_jsx(SingleReaction, { post: post, text: showText
                    ? $t({ defaultMessage: 'Like', id: 'Generics.Like.Verb' })
                    : '', reaction: "+1", Icon: showIcon ? _jsx(ThumbUpIcon, { className: "w-6 h-6" }, void 0) : null }, void 0));
        case ReactionType.EMOJI_BASE:
            return (_jsx(SingleReactionWithOptions, { post: post, mainReaction: "+1", mainReactionText: $t({
                    defaultMessage: 'Like',
                    id: 'Generics.Like.Verb',
                }), options: reactions, showIcon: showIcon, showText: showText }, void 0));
        default:
            return null;
    }
};
//# sourceMappingURL=LikeAction.js.map